import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';
import { StyledProps } from './StepTracker.types';

export const Container = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  padding: 24px 48px;
`;

export const Step = styled.div<StyledProps>`
  position: relative;
  overflow: visible;
  white-space: nowrap;
  text-align: center;
  cursor: ${({ isPastStep }) => (isPastStep ? 'pointer' : 'default')};
  border-radius: 50%;
  border: none;
  padding: 0;
  line-height: ${rem(21)};

  :focus-within {
    ${({ theme }) => theme.states.focus};
    outline-offset: 2px;
  }
`;

export const Line = styled.div<StyledProps>`
  width: 128px;
  height: 4px;
  background-color: ${({ theme, isFutureStep }) => (isFutureStep ? theme.colors.gray600 : theme.colors.red)};
`;

export const Label = styled.div<StyledProps>`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: ${rem(-24)};
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: ${rem(12)};
  color: ${({ theme, isCurrentStep }) => (isCurrentStep ? theme.colors.gray900 : theme.colors.gray700)};
`;

export const Circle = styled.div<StyledProps>`
  width: ${rem(24)};
  height: ${rem(24)};
  border-radius: 50%;
  border: 4px solid ${({ theme, isFutureStep }) => (isFutureStep ? theme.colors.gray600 : theme.colors.red)};
  color: ${({ theme, isFutureStep }) => (isFutureStep ? theme.colors.gray600 : theme.colors.white)};
  background-color: ${({ theme, isFutureStep }) => (isFutureStep ? theme.colors.gray200 : theme.colors.red)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  font-weight: 700;
`;
